import React, { useEffect } from "react";
import { Dialog, Slide } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewDialog({
  open,
  onClose,
  children,
  maxWidth = "sm",
  fullScreen = false,
  disableBackdropClick = false,
}) {
  const handlePopState = () => {
    if (open) {
      onClose();
      window.history.back();
    }
  };
  useEffect(() => {
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [open]);

  const handleClose = (event, reason) => {
    if (
      disableBackdropClick &&
      reason &&
      reason == "backdropClick" &&
      "escapeKeyDown"
    )
      return;
    onClose();
  };

  return (
    <Dialog
      fullWidth
      dir="rtl"
      open={open}
      maxWidth={maxWidth}
      onClose={handleClose}
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          p: 0,
          m: 0.5,
          width: "100%",
          alignSelf: { xs: "flex-end", md: "center" },
        },
      }}
    >
      {children}
    </Dialog>
  );
}
